// extracted by mini-css-extract-plugin
export default {"swatch":"DetailsColorSwatch_swatch__YdoB3","swatch-active":"DetailsColorSwatch_swatch-active__+EAD8"};